import React, { useEffect, useState } from "react";
import PageContainer from "./PageContainer";
import DetailedContainer from "./DetailedContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Typography, Box, Button, Tooltip } from "@mui/material";
import { convertFromHtml } from "../constants";
import CircularProgress from "@mui/material/CircularProgress";
import SpeciesDataGrid from "../components/country/SpeciesDataGrid";
import { BoxWrapper } from "../components/BoxWrapper";
import RiskScoreTable from "../components/country/RiskScoreTable";
import FSCNationalRiskAssessment from "../components/country/FSCNationalRiskAssessment";
import FSCv2NationalRiskAssessment from "../components/country/FSCv2NationalRiskAssessment";
import EarthwormFoundationRiskTable from "../components/country/EarthwormFoundationRiskTable";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { API_BASE_URL } from '../config';

export default function DetailedCountry() {
  const theme = useTheme();
  const { state, pathname } = useLocation();
  // const { categories } = useCategories();

  //console.log(pathname);
  const navigate = useNavigate();
  let [countryData, setCountryData] = useState<any>();

  const fetchInfo = async (countrySlug: string) => {
    console.log(countrySlug);
    const results = await fetch(
      `${API_BASE_URL}/api/v2/countries/${countrySlug}`
    )
      .then((res) => res.json())
      .catch((err) => {
        console.log(err);
      });
    console.log(results);
    //console.log(results.species)
    setCountryData(results.items[0]);
  };

  const handleCompareClick = () => {
    navigate(`/compare?country=${countryData.meta.slug}`, {
      state: { id: countryData.id },
    });
  };

  useEffect(() => {
    if (!state) {
      let tmp = pathname.slice(pathname.lastIndexOf("/"), pathname.length);
      //console.log(tmp)
      let cleanTmp = tmp.substring(1);
      //console.log(cleanTmp)
      fetchInfo(cleanTmp);
    } else {
      fetchInfo(state.slug);
    }
  }, []);

  return (
    <PageContainer style={{ alignItems: "center" }} title={countryData?.name}>
      {/* <BoxWrapper>
                <Button sx={{ width: '10%' }} variant='contained' onClick={() => navigate('/assess-risk/countries')}>Back</Button>
            </BoxWrapper> */}
      {countryData ? (
        <DetailedContainer>
          <Button
            color="wwfGreen"
            variant="contained"
            sx={{ marginBottom: "10px" }}
            href={`/compare?country=${countryData.meta.slug}`}
          >
            Compare to Other Countries
          </Button>

          {countryData.wwf_insights ? (
            <BoxWrapper style={{}}>
              <Typography textAlign="center" variant="h4">
                Insights & Resources{" "}
              </Typography>
              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "20px",
                  borderRadius: "10px",
                  padding: "5px",
                  textAlign: "center",
                }}
                dangerouslySetInnerHTML={convertFromHtml(
                  countryData.wwf_insights
                )}
              />
            </BoxWrapper>
          ) : (
            <Box />
          )}

          <BoxWrapper style={{}}>
            <Typography textAlign="center" variant="h4">
              Risk Scores{" "}
            </Typography>
            <RiskScoreTable data={countryData} />
          </BoxWrapper>

          {countryData.fsc_v1 && (
            <FSCNationalRiskAssessment fscData={countryData.fsc_v1} />
          )}

          {countryData.fsc_v2 && (
            <FSCv2NationalRiskAssessment fscData={countryData.fsc_v2} />
          )}

          {countryData.earthworm_foundation && (
            <BoxWrapper>
              <Typography textAlign="center" variant="h4">
                Earthworm country prioritisation
              </Typography>
              <EarthwormFoundationRiskTable data={countryData.earthworm_foundation} />
            </BoxWrapper>
          )}

          <BoxWrapper style={{ height: "400px" }}>
            <Tooltip
              title={
                "A tree species native to one or more countries associated that is considered to be threatened by commercial trade and/or illegal logging, or trending toward threatened status."
              }
              placement={"top"}
            >
              <Typography textAlign="center" variant="h4">
                {" "}
                Species At Risk
                <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>{" "}
              </Typography>
            </Tooltip>
            <SpeciesDataGrid props={countryData.species} />
          </BoxWrapper>
        </DetailedContainer>
      ) : (
        <CircularProgress color="secondary" />
      )}
    </PageContainer>
  );
}
